import Members from "./account/Members";
import Profile from "./account/Profile";
import AuditLogsView from "./audit/auditLogs/AuditLogsView";
import HealthCheckView from "./audit/healthCheck/HealthCheckView";
import { categoryAccess, categoryName, pageName } from "./constants";
import AssetsNotificationsPage from "./notifications/pages/AssetsNotifications/AssetsNotificationsPage";
import GeneralNotificationsPage from "./notifications/pages/GeneralNotifications/GeneralNotificationsPage";
import RiskNotificationsPage from "./notifications/pages/RiskNotifications/RiskNotificationsPage";
import ExternalAPIView from "./organization/api/ExternalAPIView";
import HeatmapSettings from "./organization/HeatmapSettings";
import MCPPage from "./organization/integrations/MCPPage";
import SSOConfiguration from "./organization/sso/SSOConfiguration";
import StaticIPAddresses from "./organization/StaticIPAddresses";

export const pagesByCategories = {
  [categoryName.ORGANIZATION_SETTINGS]: {
    menuTitle: "Organization Settings",
    access: categoryAccess.MANAGERS_ONLY,
    pages: {
      [pageName.SSO]: { menuTitle: "SSO", component: SSOConfiguration },
      [pageName.STATIC_IP_ADDRESSES]: {
        menuTitle: "Allowlists",
        component: StaticIPAddresses,
      },
      [pageName.HEATMAP]: {
        menuTitle: "Heatmap Formula",
        component: HeatmapSettings,
      },
      [pageName.MCP]: {
        menuTitle: "MCP",
        component: MCPPage,
      },
      [pageName.API_KEYS]: {
        menuTitle: "API",
        component: ExternalAPIView,
      },
    },
  },
  [categoryName.ACCOUNT]: {
    menuTitle: "Account Management",
    pages: {
      [pageName.PROFILE]: { menuTitle: "Profile", component: Profile },
      [pageName.MEMBERS]: { menuTitle: "Members", component: Members },
    },
  },
  [categoryName.ORGANIZATION_NOTIFICATIONS]: {
    menuTitle: "Organization Notifications",
    access: categoryAccess.MANAGERS_ONLY,
    pages: {
      [pageName.GENERAL]: {
        menuTitle: "General",
        component: GeneralNotificationsPage,
      },
      [pageName.RISK]: {
        menuTitle: "Risk",
        component: RiskNotificationsPage,
      },
      [pageName.ASSETS]: {
        menuTitle: "Assets",
        component: AssetsNotificationsPage,
      },
    },
  },
  [categoryName.PERSONAL]: {
    menuTitle: "Personal Notifications",
    access: categoryAccess.ALL,
    pages: {
      [pageName.GENERAL]: {
        menuTitle: "General",
        component: GeneralNotificationsPage,
      },
      [pageName.RISK]: {
        menuTitle: "Risk",
        component: RiskNotificationsPage,
      },
      [pageName.ASSETS]: {
        menuTitle: "Assets",
        component: AssetsNotificationsPage,
      },
    },
  },
  [categoryName.AUDIT]: {
    menuTitle: "Audit",
    access: categoryAccess.ALL,
    pages: {
      [pageName.SCAN_HEALTH]: {
        menuTitle: "Scan Health",
        component: HealthCheckView,
      },
      [pageName.AUDIT_LOGS]: {
        menuTitle: "Audit Logs",
        component: AuditLogsView,
      },
    },
  },
};
